module.exports = __webpack_public_path__ + "static/media/beauty.defb9858.jpg";